module.exports = __webpack_public_path__ + "img/storage box.9021295c.svg";